import React from "react";
import "./style.scss";

//import components
import Navbar from "../../components/cards/nav/Navbar";
import Header from "../../components/cards/header/Header";
import Partners from "../../components/cards/partners/Partners";
import Approach from "../../components/cards/approach/Approach";
import GetPaidSteps from "../../components/cards/howtogetpaid/GetPaidSteps";
import StackUp from "../../components/cards/howwestack/StackUp";
import Testimonials from "../../components/cards/testimonials/Testimonials";
import Faq from "../../components/cards/faq/Faq";

const Landing = (props) => {
  return (
    <div className="landing__page">
      <Navbar />
      <Header
        largeText="Get money for what’s next"
        subText="Sell your e-commerce business to OpenStore. It’s fast and easy."
      />
      <Partners />
      <Approach />
      <GetPaidSteps />
      <StackUp />
      <Testimonials />
      <Faq />
    </div>
  );
};

Landing.propTypes = {};

export default Landing;
